import { render, staticRenderFns } from "./ComplianceScopePage.vue?vue&type=template&id=0bceaf96"
import script from "./ComplianceScopePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComplianceScopePage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports